const pageUrlRegex = /^(new|used|certified)$/;

const pageUrlMap = {
    new: '/car-topics/new-car-buying',
    used: '/car-shopping',
    certified: '/car-topics/certified-car-buying',
};

const getUrlByPageValue = (pageValue) => {
    const match = pageUrlRegex.exec(pageValue);
    if (match) {
        return pageUrlMap[match[1]];
    }
    return `/car-topics/${pageValue}-car-buying.xhtml`;
};

export default getUrlByPageValue;
